// extracted by mini-css-extract-plugin
export default {"section":"Section_section__5Qxm5","dark":"Section_dark__b7f5h"};